import React from "react";

import useIsLoggedIn from "../../hooks/use-IsLoggedIn";
import Header from "../Profile/components/Header";
import ViewJob from "../StaticPages/HomePage/components/ViewJob";

function SpecificJobDetails() {
	const isLoggedIn = useIsLoggedIn();
	return (
		<div className="min-h-screen">
			<Header isLoggedIn={isLoggedIn} />
			<ViewJob />
		</div>
	);
}

export default SpecificJobDetails;
